const RouterRecord = require('./record')

function routerReducer(state = new RouterRecord()) {
  // TODO Implement navigation without full-page refresh
  // See: https://app.asana.com/0/102902769366319/681203866231475/f
  return state
}

module.exports = routerReducer
